module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-RegularItalic-6f9d752b79d252d1121ed0a7e4cb2fa7.woff2";